module.exports = __webpack_public_path__ + "assets/Hotspot-Circle.7b791d97.svg";